import { Box, Skeleton } from "@mui/material"

export function MessageSkeleton() {
  return <Box className="message skeleton">
    <Skeleton className="message-content" variant="rounded" height={45} />
  </Box>
}
